const apis = [
  {
    // 历史作品分页列表
    fn: 'getPageList',
    method: 'POST',
    url: '/api/jsHistoricalWork/getPageList',
    hideLoading: true
  },
  {
    // 添加历史作品
    fn: 'add',
    method: 'POST',
    url: '/api/jsHistoricalWork/add',
    hideLoading: true
  },
  {
    // 修改历史作品
    fn: 'update',
    method: 'POST',
    url: '/api/jsHistoricalWork/update',
    hideLoading: true
  },
  {
    // 删除历史作品
    fn: 'delete',
    method: 'POST',
    url: '/api/jsHistoricalWork/delete',
    hideLoading: true
  },
  {
    // 历史作品详情
    fn: 'info',
    method: 'GET',
    url: '/api/jsHistoricalWork/info',
    hideLoading: true
  }
]

export default apis
